var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrectIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 489.47018 347.76738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_21);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_21",
    x1: 337.40439,
    y1: 212.48508,
    x2: 549.6767,
    y2: 424.75739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21572,
    stopColor: "#00fd6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3786,
    stopColor: "#00f577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52415,
    stopColor: "#00e987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65963,
    stopColor: "#00d79e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78812,
    stopColor: "#00c0bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90961,
    stopColor: "#00a5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008cff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M673.631,230.09247l-.00006-.00006a50,50,0,0,0-70.71063,0L390.36707,442.64563l-106.2063-106.2063a49.99991,49.99991,0,0,0-70.71064,0l-.00006.00006a49.99993,49.99993,0,0,0,0,70.71057L354.87152,548.57141a50.69962,50.69962,0,0,0,71.272-.28088L673.631,300.8031A50,50,0,0,0,673.631,230.09247Z",
    transform: "translate(-198.80544 -215.44777)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIc);
export default __webpack_public_path__ + "static/media/correct-ic.4a8e513ea3f10481fd6959aae16ea8fb.svg";
export { ForwardRef as ReactComponent };